import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "metric-box" }
const _hoisted_4 = { class: "metric-box" }
const _hoisted_5 = { class: "metric-box" }
const _hoisted_6 = { class: "metric-box" }
const _hoisted_7 = { class: "metric-box" }
const _hoisted_8 = { class: "metric-box" }
const _hoisted_9 = { class: "metric-box" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "pager" }
const _hoisted_13 = { class: "pager" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_Stats = _resolveComponent("Stats")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_calendar = _resolveComponent("el-calendar")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Search = _resolveComponent("Search")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.DASHBOARD,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_main, { class: "rounded-content calendar" }, {
          default: _withCtx(() => [
            (_ctx.hasPermission['DASH_STATS'])
              ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 0,
                  "content-position": "center"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Statistik")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_STATS'])
              ? (_openBlock(), _createBlock(_component_Stats, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_TESTS'])
              ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 2,
                  "content-position": "center"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Prüfungen")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_TESTS'] && !_ctx.loadingMetrics)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 3,
                  gutter: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createTextVNode(" Abgeschlossen ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(Math.round(_ctx.metricCountModel.count_test_done)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupModelList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 20
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 4,
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getMetricValue(2, item.name)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode(" Geplant ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_test_planned), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupModelList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 20
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 4,
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getMetricValue(1, item.name)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode(" Prüflinge ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_participant_total), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupModelList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 20
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 4,
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getMetricValue(3, item.name)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode(" Bestehensquote ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString((_ctx.metricCountModel.count_participant_passed > 0 && _ctx.metricCountModel.count_participant_total > 0) ? (Math.round(_ctx.metricCountModel.count_participant_passed / _ctx.metricCountModel.count_participant_total * 100)) : '0') + "% ", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupModelList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 20
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 4,
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getMetricValue(3, item.name) > 0 && _ctx.getMetricValue(4, item.name) > 0 ? Math.round(_ctx.getMetricValue(4, item.name) / _ctx.getMetricValue(3, item.name) * 100) : 0) + "% ", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_QUESTIONS'])
              ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 4,
                  "content-position": "center"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("Fragendatenbank")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_QUESTIONS'])
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 5,
                  gutter: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode(" Fragenstamm ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_question_total), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode(" in mehr als 5 Prüfungen verwendet ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_question_usage), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode(" nie verwendet ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_question_unused), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode(" unzureichende Antwortmöglichkeiten ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_question_missing), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" ungeeignet für Single Choice ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_question_missing_single), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode(" Antwortmöglichkeiten ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_option_total), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                  _createTextVNode(" in mehr als 5 Prüfungen verwendet ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_option_usage), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                  _createTextVNode(" nie verwendet ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_option_unused), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, {
                            class: "metric-row",
                            onClick: _ctx.onMissingReferencesClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                  _createTextVNode(" ohne Referenz ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_option_noreference), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createTextVNode(" aufgrund Widerspruch gesperrt ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.metricCountModel.count_option_locked), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 12,
                      md: 10,
                      lg: 6,
                      xl: 6
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_el_row, { class: "metric-row" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                  _createTextVNode(" Fragen in Zielgruppen ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-title",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getMetricSum(6)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_divider, { "content-position": "center" }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode("davon")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupModelList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_row, { class: "metric-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 20
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  class: "metric-col-field",
                                  span: 4,
                                  align: "right"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getMetricValue(5, item.name)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 256)),
                          _createVNode(_component_el_row, {
                            class: "metric-row",
                            onClick: _ctx.onMissingTargetgroupClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 20
                              }, {
                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                  _createTextVNode(_toDisplayString('nicht zugewiesen'))
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                class: "metric-col-field",
                                span: 4,
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getMetricValue(5, 'nicht zugewiesen')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_CALENDAR'])
              ? (_openBlock(), _createBlock(_component_el_divider, {
                  key: 6,
                  "content-position": "center"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("Kalender")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.hasPermission['DASH_CALENDAR'] && !_ctx.loading)
              ? (_openBlock(), _createBlock(_component_el_calendar, {
                  key: 7,
                  modelValue: _ctx.currentDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.currentDate) = $event))
                }, {
                  "date-cell": _withCtx(({ data }) => [
                    _createElementVNode("div", null, _toDisplayString(data.day.split('-').slice(1)[1]), 1),
                    (_ctx.getCalendarEvents(data) && _ctx.getCalendarEvents(data).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCalendarEvents(data), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: $event => (_ctx.onDateClick(item.testid))
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(item.class + '-title')
                              }, _toDisplayString(item.title), 3)
                            ], 8, _hoisted_11))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          title: "Antwortmöglichkeiten ohne Referenz",
          modelValue: _ctx.showMissingReferences,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showMissingReferences) = $event)),
          top: "20px",
          width: "90%",
          center: ""
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.filterMissingReferences,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterMissingReferences) = $event)),
                placeholder: "Filter",
                onInput: _ctx.onFilterMissingReferencesChange,
                clearable: ""
              }, null, 8, ["modelValue", "onInput"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.metricMissingReferenceDisplayList }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "question_position",
                    label: "Frage Nr.",
                    width: "90",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingReferenceDisplayList[scope.$index].question_position), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "question",
                    label: "Frage"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingReferenceDisplayList[scope.$index].question), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "option_position",
                    label: "Antwort Nr.",
                    width: "120",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingReferenceDisplayList[scope.$index].option_position), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "option",
                    label: "Antwortmöglichkeit"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingReferenceDisplayList[scope.$index].option), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "",
                    width: "60"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: $event => (_ctx.onMissingReferenceSelect(_ctx.metricMissingReferenceDisplayList[scope.$index])),
                        circle: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Search)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loadingMetricsMissingReferences]
              ]),
              _cache[32] || (_cache[32] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  total: _ctx.metricMissingReferenceFilteredList.length,
                  pageSize: _ctx.referenceRowsPerPage,
                  pagerCount: _ctx.referencePagerCount,
                  currentPage: _ctx.referencePage,
                  onCurrentChange: _ctx.onReferencePageChange
                }, null, 8, ["total", "pageSize", "pagerCount", "currentPage", "onCurrentChange"])
              ])
            ])), [
              [_directive_loading, _ctx.loadingMetricsMissingReferences]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          title: "Fragen die keiner Zielgruppe zugewiesen sind",
          modelValue: _ctx.showMissingTargetgroups,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.showMissingTargetgroups) = $event)),
          top: "20px",
          width: "90%",
          center: ""
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.filterMissingTargetgroup,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filterMissingTargetgroup) = $event)),
                placeholder: "Filter",
                onInput: _ctx.onFilterMissingTargetgroupChange,
                clearable: ""
              }, null, 8, ["modelValue", "onInput"]),
              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.metricMissingTargetgroupDisplayList }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "position",
                    label: "Frage Nr.",
                    width: "90",
                    align: "right"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingTargetgroupDisplayList[scope.$index].position), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "question",
                    label: "Frage"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(_ctx.metricMissingTargetgroupDisplayList[scope.$index].question), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    fixed: "right",
                    label: "",
                    width: "60"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: $event => (_ctx.onMissingTargetgroupSelect(_ctx.metricMissingTargetgroupDisplayList[scope.$index])),
                        circle: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Search)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loadingMetricsMissingTargetgroups]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next, jumper",
                  total: _ctx.metricMissingTargetgroupFilteredList.length,
                  pageSize: _ctx.targetgroupRowsPerPage,
                  pagerCount: _ctx.targetgroupPagerCount,
                  currentPage: _ctx.targetgroupPage,
                  onCurrentChange: _ctx.onTargetgroupPageChange
                }, null, 8, ["total", "pageSize", "pagerCount", "currentPage", "onCurrentChange"])
              ])
            ])), [
              [_directive_loading, _ctx.loadingMetricsMissingTargetgroups]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}